import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../slices/user/userSlice";
import languageReducer from "../slices/language/languageSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  // devTools: false,
});

export default store;
